/**
 * 
 * key
 * 
 */


const key = 'ZXF1aXBtZW50VW5NYXBwaW5n'

export default key 